/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateTodoDto } from '../models/work-create-todo-dto';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkTodo } from '../models/work-todo';
import { WorkUpdateTodoDto } from '../models/work-update-todo-dto';

@Injectable({ providedIn: 'root' })
export class WorkTodosV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `todosV2ControllerFindAllPaginated()` */
  static readonly TodosV2ControllerFindAllPaginatedPath = '/v2/todos';

  /**
   * Required permissions: todos:read, todos:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `todosV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  todosV2ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 200
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by assignedToUserId query param.
     *           <p>
     *              <b>Format: </b> filter.assignedToUserId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.assignedToUserId=$not:$like:John Doe&filter.assignedToUserId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.assignedToUserId'?: Array<string>;

    /**
     * Filter by createdByUserId query param.
     *           <p>
     *              <b>Format: </b> filter.createdByUserId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.createdByUserId=$not:$like:John Doe&filter.createdByUserId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.createdByUserId'?: Array<string>;

    /**
     * Filter by meetingId query param.
     *           <p>
     *              <b>Format: </b> filter.meetingId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.meetingId=$not:$like:John Doe&filter.meetingId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$null</li></ul>
     */
      'filter.meetingId'?: Array<string>;

    /**
     * Filter by meetingAgendaItemId query param.
     *           <p>
     *              <b>Format: </b> filter.meetingAgendaItemId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.meetingAgendaItemId=$not:$like:John Doe&filter.meetingAgendaItemId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.meetingAgendaItemId'?: Array<string>;

    /**
     * Filter by completedAt query param.
     *           <p>
     *              <b>Format: </b> filter.completedAt={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.completedAt=$not:$like:John Doe&filter.completedAt=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.completedAt'?: Array<string>;

    /**
     * Filter by priority query param.
     *           <p>
     *              <b>Format: </b> filter.priority={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.priority=$not:$like:John Doe&filter.priority=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
      'filter.priority'?: Array<string>;

    /**
     * Filter by status query param.
     *           <p>
     *              <b>Format: </b> filter.status={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.status=$not:$like:John Doe&filter.status=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
      'filter.status'?: Array<string>;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> dueAt:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>dueAt</li>
     * <li>priority</li>
     * <li>completedAt</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'dueAt:ASC' | 'dueAt:DESC' | 'priority:ASC' | 'priority:DESC' | 'completedAt:ASC' | 'completedAt:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> title,description
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>title</li>
     * <li>description</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkTodo>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'assignedToUserId'?: (string | Array<string>);
'createdByUserId'?: (string | Array<string>);
'meetingId'?: (string | Array<string>);
'meetingAgendaItemId'?: (string | Array<string>);
'completedAt'?: (string | Array<string>);
'priority'?: (string | Array<string>);
'status'?: (string | Array<string>);
'active'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTodosV2Service.TodosV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.assignedToUserId', params['filter.assignedToUserId'], {});
      rb.query('filter.createdByUserId', params['filter.createdByUserId'], {});
      rb.query('filter.meetingId', params['filter.meetingId'], {});
      rb.query('filter.meetingAgendaItemId', params['filter.meetingAgendaItemId'], {});
      rb.query('filter.completedAt', params['filter.completedAt'], {});
      rb.query('filter.priority', params['filter.priority'], {});
      rb.query('filter.status', params['filter.status'], {});
      rb.query('filter.active', params['filter.active'], {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkTodo>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'assignedToUserId'?: (string | Array<string>);
        'createdByUserId'?: (string | Array<string>);
        'meetingId'?: (string | Array<string>);
        'meetingAgendaItemId'?: (string | Array<string>);
        'completedAt'?: (string | Array<string>);
        'priority'?: (string | Array<string>);
        'status'?: (string | Array<string>);
        'active'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: todos:read, todos:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `todosV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  todosV2ControllerFindAllPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 200
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by assignedToUserId query param.
     *           <p>
     *              <b>Format: </b> filter.assignedToUserId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.assignedToUserId=$not:$like:John Doe&filter.assignedToUserId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.assignedToUserId'?: Array<string>;

    /**
     * Filter by createdByUserId query param.
     *           <p>
     *              <b>Format: </b> filter.createdByUserId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.createdByUserId=$not:$like:John Doe&filter.createdByUserId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.createdByUserId'?: Array<string>;

    /**
     * Filter by meetingId query param.
     *           <p>
     *              <b>Format: </b> filter.meetingId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.meetingId=$not:$like:John Doe&filter.meetingId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$null</li></ul>
     */
      'filter.meetingId'?: Array<string>;

    /**
     * Filter by meetingAgendaItemId query param.
     *           <p>
     *              <b>Format: </b> filter.meetingAgendaItemId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.meetingAgendaItemId=$not:$like:John Doe&filter.meetingAgendaItemId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.meetingAgendaItemId'?: Array<string>;

    /**
     * Filter by completedAt query param.
     *           <p>
     *              <b>Format: </b> filter.completedAt={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.completedAt=$not:$like:John Doe&filter.completedAt=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.completedAt'?: Array<string>;

    /**
     * Filter by priority query param.
     *           <p>
     *              <b>Format: </b> filter.priority={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.priority=$not:$like:John Doe&filter.priority=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
      'filter.priority'?: Array<string>;

    /**
     * Filter by status query param.
     *           <p>
     *              <b>Format: </b> filter.status={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.status=$not:$like:John Doe&filter.status=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
      'filter.status'?: Array<string>;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> dueAt:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>dueAt</li>
     * <li>priority</li>
     * <li>completedAt</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'dueAt:ASC' | 'dueAt:DESC' | 'priority:ASC' | 'priority:DESC' | 'completedAt:ASC' | 'completedAt:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> title,description
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>title</li>
     * <li>description</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkTodo>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'assignedToUserId'?: (string | Array<string>);
'createdByUserId'?: (string | Array<string>);
'meetingId'?: (string | Array<string>);
'meetingAgendaItemId'?: (string | Array<string>);
'completedAt'?: (string | Array<string>);
'priority'?: (string | Array<string>);
'status'?: (string | Array<string>);
'active'?: (string | Array<string>);
};
};
}> {
    return this.todosV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkTodo>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'assignedToUserId'?: (string | Array<string>);
'createdByUserId'?: (string | Array<string>);
'meetingId'?: (string | Array<string>);
'meetingAgendaItemId'?: (string | Array<string>);
'completedAt'?: (string | Array<string>);
'priority'?: (string | Array<string>);
'status'?: (string | Array<string>);
'active'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkTodo>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'assignedToUserId'?: (string | Array<string>);
'createdByUserId'?: (string | Array<string>);
'meetingId'?: (string | Array<string>);
'meetingAgendaItemId'?: (string | Array<string>);
'completedAt'?: (string | Array<string>);
'priority'?: (string | Array<string>);
'status'?: (string | Array<string>);
'active'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `todosV2ControllerCreate()` */
  static readonly TodosV2ControllerCreatePath = '/v2/todos';

  /**
   * Required permissions: todos:create, todos:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `todosV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  todosV2ControllerCreate$Response(
    params: {
      body: WorkCreateTodoDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTodo>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTodosV2Service.TodosV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTodo>;
      })
    );
  }

  /**
   * Required permissions: todos:create, todos:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `todosV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  todosV2ControllerCreate(
    params: {
      body: WorkCreateTodoDto
    },
    context?: HttpContext
  ): Observable<WorkTodo> {
    return this.todosV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTodo>): WorkTodo => r.body)
    );
  }

  /** Path part for operation `todosV2ControllerFindOneById()` */
  static readonly TodosV2ControllerFindOneByIdPath = '/v2/todos/{id}';

  /**
   * Required permissions: todos:read, todos:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `todosV2ControllerFindOneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  todosV2ControllerFindOneById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTodo>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTodosV2Service.TodosV2ControllerFindOneByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTodo>;
      })
    );
  }

  /**
   * Required permissions: todos:read, todos:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `todosV2ControllerFindOneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  todosV2ControllerFindOneById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkTodo> {
    return this.todosV2ControllerFindOneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTodo>): WorkTodo => r.body)
    );
  }

  /** Path part for operation `todosV2ControllerDelete()` */
  static readonly TodosV2ControllerDeletePath = '/v2/todos/{id}';

  /**
   * Required permissions: todos:delete, todos:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `todosV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  todosV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTodosV2Service.TodosV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: todos:delete, todos:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `todosV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  todosV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.todosV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `todosV2ControllerUpdate()` */
  static readonly TodosV2ControllerUpdatePath = '/v2/todos/{id}';

  /**
   * Required permissions: todos:update, todos:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `todosV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  todosV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateTodoDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTodo>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTodosV2Service.TodosV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTodo>;
      })
    );
  }

  /**
   * Required permissions: todos:update, todos:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `todosV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  todosV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateTodoDto
    },
    context?: HttpContext
  ): Observable<WorkTodo> {
    return this.todosV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTodo>): WorkTodo => r.body)
    );
  }

}
